import { Gavel, Sync, Settings, Person, Stadium, Widgets, ReportProblem, Language, QuestionAnswer, FontDownload, Email, Create, FilterAlt, Topic, Backup } from "@mui/icons-material";
import SysVersion from "./SysVersion";
import SysGeneral, { schema as SysGeneralSchema } from "./SysGeneral/SysGeneral";
import SysBnR from "./SysBnR/SysBnR";
import SysUserProfile from "./SysUser/SysUserProfile";
import SysNLP, { schema as SysNLPSchema } from "./SysNLP/SysNLP";
import SysChatbot, { schema as SysChatbotSchema } from "./SysChatbot/SysChatbot";
import SysTexts, { schema as SysTextSchema } from "./SysTexts/SysTexts";
import SysSpamSetting, { schema as SysSpamsettingSchema } from "./SysSpamSetting/SysSpamSetting";
import SysEmail, { schema as SysEmailSchema } from "./SysEmail/SysEmail";
import SysArena, { schema as SysArenaSchema } from "./SysArena/SysArena";
import SysModel, { schema as SysModelSchema } from "./SysModel/SysModel";
import SysIntent, { schema as SysIntentSchema } from "./SysIntent/SysIntent";
import SysContentFilter, { schema as SysContentFilterSchema } from "./SysContentFilter/SysContentFilter";
import { FormizoSchema } from "Components/LabIZO/Formizo";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import SysChannel, { schema as SysChannelSchema } from "./SysChannel/SysChannel";
import SysTopicClustering, { schema as SysTopicClusterSchema } from "./SysTopicClustering/SysTopicClustering";
import SysUserBnR from "./SysUserBnR/SysUserBnR";

export interface TabConfig {
  label: string;
  icon: React.ReactElement;
  reqAuth: string;
  iconPos: string;
  noTransform: boolean;
  render: JSX.Element;
  alignment?: string;
  type: "General" | "GPT" | "Chatbot" | "User";
  reqLevel?: number;
  reqFunc?: string;
  schema?: FormizoSchema[];
}

export const tabs: TabConfig[] = [
  {
    label: "Version",
    icon: <Gavel />,
    reqAuth: "System.General",
    iconPos: "left",
    noTransform: true,
    render: <SysVersion />,
    type: "General",
  },
  {
    label: "General",
    icon: <Settings />,
    reqAuth: "System.General",
    iconPos: "left",
    noTransform: true,
    render: <SysGeneral />,
    type: "General",
    schema: SysGeneralSchema,
  },
  {
    label: "Backup & Restore",
    icon: <Sync />,
    reqAuth: "System.BnR",
    render: <SysBnR />,
    iconPos: "left",
    noTransform: true,
    alignment: "left",
    type: "General",
  },
  {
    label: "User Backup & Restore",
    icon: <Backup />,
    reqAuth: "System.UserBnR",
    render: <SysUserBnR />,
    iconPos: "left",
    noTransform: true,
    alignment: "left",
    type: "General",
  },
  {
    label: "Intent Generation",
    icon: <Create />,
    reqAuth: "System.IntentGeneration",
    render: <SysIntent />,
    iconPos: "left",
    noTransform: true,
    alignment: "left",
    type: "General",
    schema: SysIntentSchema,
  },
  {
    label: "Topic Clustering",
    icon: <Topic />,
    reqAuth: "System.TopicClustering",
    render: <SysTopicClustering />,
    iconPos: "left",
    noTransform: true,
    alignment: "left",
    type: "General",
    schema: SysTopicClusterSchema,
  },
  {
    label: "User Profile",
    icon: <Person />,
    reqAuth: "System.User",
    render: <SysUserProfile />,
    iconPos: "left",
    noTransform: true,
    alignment: "left",
    type: "User",
  },
  {
    label: "NLP Setting",
    icon: <Language />,
    iconPos: "left",
    noTransform: true,
    reqAuth: "System.NLP",
    render: <SysNLP />,
    type: "Chatbot",
    schema: SysNLPSchema,
  },
  {
    label: "Chatbot",
    icon: <QuestionAnswer />,
    reqAuth: "System.Chatbot",
    iconPos: "left",
    noTransform: true,
    render: <SysChatbot />,
    type: "Chatbot",
    schema: SysChatbotSchema,
  },
  {
    label: "Texts",
    icon: <FontDownload />,
    reqAuth: "System.Texts",
    iconPos: "left",
    noTransform: true,
    render: <SysTexts />,
    type: "Chatbot",
    schema: SysTextSchema,
  },
  {
    label: "SPAM Setting",
    icon: <ReportProblem />,
    reqAuth: "System.Spam",
    iconPos: "left",
    noTransform: true,
    render: <SysSpamSetting />,
    type: "Chatbot",
    schema: SysSpamsettingSchema,
  },
  {
    label: "Content Filter",
    icon: <FilterAlt />,
    reqAuth: "System.ContentFilter",
    iconPos: "left",
    noTransform: true,
    render: <SysContentFilter />,
    type: "Chatbot",
    schema: SysContentFilterSchema,
  },
  {
    label: "Email",
    icon: <Email />,
    reqAuth: "System.Email",
    iconPos: "left",
    noTransform: true,
    render: <SysEmail />,
    type: "Chatbot",
    schema: SysEmailSchema,
  },
  {
    label: "Channel Setting",
    icon: <WhatsAppIcon />,
    reqAuth: "System.Channel",
    iconPos: "left",
    noTransform: true,
    render: <SysChannel />,
    type: "Chatbot",
    schema: SysChannelSchema,
  },
  {
    label: "Model Setting",
    icon: <Widgets />,
    iconPos: "left",
    noTransform: true,
    reqAuth: "System.Model",
    render: <SysModel />,
    type: "GPT",
    schema: SysModelSchema,
  },
  {
    label: "Chatbot Arena",
    icon: <Stadium />,
    reqAuth: "System.Arena",
    iconPos: "left",
    noTransform: true,
    render: <SysArena />,
    type: "GPT",
    schema: SysArenaSchema,
  },
];
